import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import t from 'ember-intl/helpers/t';
import type { IntlService } from 'ember-intl';
import { Header, VStack } from 'tio-ui/components/layout';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import LoanPlansSection from 'tio-common/components/strategy-finder-0726/loan-plans-section';
import { parseAndFilterResultSections } from 'tio-employee/utils/idr-dashboard-0726';

interface IdrDashboard0726ResultsTableSignature {
  Args: {
    recommendation: RecommendationModel;
  };
  Element: HTMLElement;
}

export default class IdrDashboard0726ResultsTableComponent extends Component<IdrDashboard0726ResultsTableSignature> {
  @service declare intl: IntlService;

  // Parse the stored recommendation and filter to current + income-driven plans.
  get sections() {
    return parseAndFilterResultSections(
      this.args.recommendation.calculationInput,
      this.args.recommendation.calculationOutput
    );
  }

  <template>
    <VStack data-test-idr-0726-results ...attributes>
      <Header>
        {{t "strategy_finder_0726.results.title"}}
      </Header>
      {{#if @recommendation.hasErrorsInCalcs}}
        <div class="m-2" data-test-idr-0726-results-error>
          {{t "strategy_finder_0726.results.error_in_calcs"}}
          <LinkTo @route="authenticated.idr.dashboard.questionnaire" class="tio-copy">
            {{t "strategy_finder_0726.results.error_link_text"}}
          </LinkTo>
        </div>
      {{else}}
        {{#each this.sections as |section|}}
          <LoanPlansSection @section={{section}} @analysisDate={{@recommendation.createdAt}} />
        {{/each}}
      {{/if}}
    </VStack>
  </template>
}
